"use client";

import * as React from "react";
import { cn } from "@/utils";

interface ParagraphProps {
  className?: string;
  children: React.ReactNode;
  variant?: "default" | "lead" | "caption";
}

export function Paragraph({
  children,
  className,
  variant = "default",
}: ParagraphProps) {
  return (
    <p
      className={cn(
        "leading-relaxed text-foreground [text-wrap:_balance]",
        variant === "default" && "mb-12",
        variant === "lead" &&
          "mb-10 max-w-3xl border-l-2 border-hex-400/40 pl-5 text-base leading-7 text-white/80 md:text-lg md:leading-8",
        variant === "caption" &&
          "mb-0 text-sm leading-6 text-muted md:text-[0.9375rem]",
        className,
      )}
    >
      {children}
    </p>
  );
}

export default Paragraph;
